import {parseWorld} from "@frog/source/utility/Parser.js"

const protoworlds = require("@frog/source/data/worlds.csv")

const WORLD_WIDTH = 6
const WORLD_HEIGHT = 6
const WORLD_DEPTH = 4

const worlds = {}

for(let row = 0; row < protoworlds.length; row += WORLD_HEIGHT+1) {
    const protoworld = protoworlds.slice(row, row + WORLD_HEIGHT)
    const {world} = parseWorld(protoworld)
    worlds[world.key] = world
}

export default worlds
